import { observer } from 'mobx-react-lite';
import React from 'react';
import useForm from './customHooks'; 

const LoginForm = observer(({ cartStore }) => { 
  const {inputs, handleInputChange, handleSubmit} = useForm({email:'',password:''});
  return (
    <>
    

    
      <h5>Registrierte Kunden</h5> 
     
      <h5>
      Wenn Du bereits ein Benutzerkonto besitzt, melde Dich bitte hier an. 
      </h5>
      <form onSubmit = "submit">
      <div className="row mb-3">
          <div className="col-sm-12 col-md-12">
            <input
              type="email"
              placeholder="E-Mail"
              name="login_email"
              className="form-control"
              id="login_email"
              onChange={(e) =>
                cartStore.updateLoginForm('login_email', e.target.value)
              }
              autoComplete="email" 
              required={true}
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <input
              type="password"
              name="password"
              id="password"
              className="form-control"
              placeholder="Passwort"
              onChange={(e) =>
                cartStore.updateLoginForm('password', e.target.value)
              }
              autoComplete="register register_firstname"
              required={true}
             
            />
          </div>
        </div>
        <button type="submit">Anmelden</button>   
        </form>


    </>
  );
});
export default LoginForm;  
